import React from 'react';

const getSecureItem = list => index => {
  if (index >= 0) {
    return index < list.length ? list[index] : list[list.length - 1];
  }
  return list[0];
};

const strengthClassList = ['--weak', '--regular', '--good', '--best'];
const getStrengthColor = getSecureItem(strengthClassList);

const getStrengthClass = (min, score) => (score >= min ? getStrengthColor(score) : '');

const PasswordText = ['fraca', 'regular', 'boa', 'ótima'];
const getStrengthText = getSecureItem(PasswordText);

const Score = ({ score, className }) => {
  return (
    <div className={`passwordWrapper ${className}`}>
      <div className="passwordWrapper-strength">
        <div className={`passwordWrapper-bar ${getStrengthClass(0, score)}`} />
        <div className={`passwordWrapper-bar ${getStrengthClass(1, score)}`} />
        <div className={`passwordWrapper-bar ${getStrengthClass(2, score)}`} />
        <div className={`passwordWrapper-bar ${getStrengthClass(3, score)}`} />
      </div>
      <span className="passwordWrapper-msg">senha {getStrengthText(score)}</span>
    </div>
  );
};

export default Score;
